<section class="overflow-hidden rounded-xl border-[1.5px] border-border bg-card shadow-sm"
    aria-labelledby="nogo-heading">

    <!-- header -->
    <div class="flex items-center justify-between gap-2.5 border-b border-border bg-muted px-4 py-3.5">
        <h3 id="nogo-heading" class="flex items-center gap-2.5 font-heading text-base font-bold text-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-red-500 dark:text-red-400" aria-hidden="true">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                <path d="M12 8v4" />
                <path d="M12 16h.01" />
            </svg>
            Content no-go list
        </h3>
        <span class="rounded-full px-2.5 py-0.5 text-xs font-bold"
            [class]="count() ? 'bg-brand-studio text-white' : 'bg-muted-foreground/20 text-foreground/80'">
            {{ countLabel() }}
        </span>
    </div>

    <!-- body -->
    <div class="px-4 py-3.5">
        @if (count()) {
        <ul class="m-0 flex list-none flex-col gap-2 p-0">
            @for (rule of createScreeningService.restrictions(); track rule.id) {
            <li class="flex items-center gap-3 rounded-md border border-border bg-card px-3 py-2.5">
                <span class="grid size-[26px] shrink-0 place-items-center rounded bg-red-500/10 text-red-500 dark:text-red-400"
                    aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                </span>
                <span class="min-w-0 flex-1">
                    <span class="block text-[15px] font-medium text-foreground">{{ rule.text }}</span>
                    <span class="block text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{{
                        rule.custom ? 'Custom' : rule.categoryLabel }}</span>
                </span>
                <button type="button" [attr.aria-label]="'Remove red flag: ' + rule.text" (click)="remove(rule.id)"
                    class="grid size-8 shrink-0 place-items-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18" />
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    </svg>
                </button>
            </li>
            }
        </ul>
        } @else {
        <p class="m-0 flex items-center gap-2.5 py-1.5 text-[13px] text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="m2 2 20 20" />
                <path d="M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71" />
                <path d="M9.24 3.69A17 17 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9 9 0 0 1-.09 1.24" />
            </svg>
            Nothing off-limits yet. Answer a category or add a custom rule.
        </p>
        }

        <!-- custom add -->
        <div class="mt-3.5 border-t border-dashed border-border pt-3.5">
            <h4 class="mb-2 flex items-center gap-2 text-xs font-bold text-foreground/80">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-brand-studio-dark dark:text-brand-studio" aria-hidden="true">
                    <path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72" />
                    <path d="m14 7 3 3" />
                    <path d="M5 6v4" />
                    <path d="M19 14v4" />
                    <path d="M10 2v2" />
                    <path d="M7 8H3" />
                    <path d="M21 16h-4" />
                    <path d="M11 3H9" />
                </svg>
                Add your own red flag
            </h4>
            <div class="flex gap-2">
                <input type="text" [value]="draft()" (input)="setDraft($any($event.target).value)"
                    (keydown.enter)="addDraft()" aria-label="Describe your own red flag"
                    placeholder="Describe something that should never appear…"
                    class="flex-1 rounded-md border border-border bg-card px-3.5 py-2.5 text-sm outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground" />
                <button type="button" (click)="addDraft()"
                    class="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-brand-studio px-3.5 py-2 text-sm font-bold text-white transition-opacity hover:opacity-90">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                    </svg>
                    Add
                </button>
            </div>

            <p class="mb-2 mt-2.5 text-[11px] text-muted-foreground">The AI can spot anything — try one of these:</p>
            <div class="flex flex-wrap gap-2">
                @for (example of examples; track example) {
                <button type="button" (click)="addExample(example)"
                    class="inline-flex items-center gap-1.5 rounded-full border border-border bg-muted px-3 py-1.5 text-[12.5px] font-medium text-foreground/80 transition-colors hover:border-brand-studio hover:bg-brand-studio/10 hover:text-brand-studio-dark dark:hover:text-brand-studio">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                    </svg>
                    {{ example }}
                </button>
                }
            </div>
        </div>
    </div>
</section>
